module.exports = __webpack_public_path__ + "static/Anmeldung-Screen-0c03f86a12fe5da028243e3f99505db7.png";